import React from 'react';

export default class ChoroplethDangerousPatternDefiner extends React.Component {
  GRAY_COLOR = [191, 191, 191];
  NULL_COLOR = [255, 255, 255];
  ANGLES = [135, 135, 0, 45, 45];
  DENSITIES = [10, 5, 7, 5, 10];
  
  constructor(props) {
    super(props);
  };

  patternColor(index) {
    if (index >= 2)
      return this.props.colorBins[0]
    else
      return this.props.colorBins[4]
  }

  backgroundColor(index) {
    return this.props.colorBins[index]
  }

  arrToRGB(colorArr) {
    return `rgb(${colorArr})`;
  };
  
  getDashedPatternHTML(name, density, size, rotation) {
    return (`
      <pattern id=${name} width=${density} height=${density}
        patternTransform="rotate(${rotation})" patternUnits="userSpaceOnUse">
        <rect class="choropleth-pattern-background" width=${density} height=${density}></rect>
        <rect class="choropleth-pattern-foreground" y=${0.5 * (density - size)} height=${size} width=${density}></rect>
      </pattern>
    `)
  }
  
  getDangerousPatternHTML() {
    return this.props.colorBins.reduce((html, colorBin, index) => {
      const name = this.props.names[index];
      const density = this.DENSITIES[index];
      const size = 1;
      const rotation = this.ANGLES[index];
      return html + this.getDashedPatternHTML(name, density, size, rotation);
    }, "") + this.getDashedPatternHTML('no-data-pattern', 10, 0.7, 90)
  }

  render() {
    // const names = this.props.names;
    // const colorBins = this.props.colorBins;
    // const patternColors = this.props.patternColors;
    return (
      <defs dangerouslySetInnerHTML={{ __html: this.getDangerousPatternHTML() }} />
    );
  };
}
